define('views/modals/messenger/footer',['require','views/base/modal-footer','text!templates/modals/messenger/footer.ejs'],function(require) {
    'use strict';

    var ModalFooterView = require('views/base/modal-footer'),
        templateFooter = require('text!templates/modals/messenger/footer.ejs');

    var MessengerModalFooterView = ModalFooterView.extend({
        template: templateFooter
    });

    return MessengerModalFooterView;
});

